import React from 'react'
import { ReactComponent as ThankyouImage } from "../../../images/thank-you/success.svg"
import "./product-question-thankyou.scss"
import StepButton from '../../common/StepButton'
import { webBaseUrl } from '../../../config'

function ProductquestionThankyou() {
//   function getCookie(name) {
//     const value = `; ${document.cookie}`;
//     const parts = value.split(`; ${name}=`);
//     if (parts.length === 2) {
//       return parts.pop().split(';').shift();
//     }
//     return null; // Return null if the cookie is not found
//   }

  // Usage
//   const facesAccessToken = getCookie('faces_access_token');
    
  return (
    <div className='CustomProductThankyouPageContainer'>
    <div className='product-thankyou-page-content-container ModelMaxWidth540'>
      <ThankyouImage />
      <h1>This product has been sent to the Faces admin team for approval. </h1>
      <p>You will be notified once it is available to the public.<br/> For any queries, contact Customer Support  on <b>+44 7999 875249</b> <br/> <b>eMail: support@facesconsent.com</b> or contact your account manager Danica on ‪<b>+44 7539 696790</b>‬. <b>email: Danica@facesconsent.com</b></p>

      {/* {facesAccessToken === null && <StepButton label={'Go to shop '} blue={true} onClick={() => { window.location.href = webBaseUrl + "/shop " }} />} */}
      <StepButton label={'Go to products list'} blue={true} 
      onClick={() => {window.location.href = webBaseUrl + "/product/lists" }}

      />
      </div>
  </div>
  )
}

export default ProductquestionThankyou